import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة كتلة الماء - حساب كتلة الماء بناءً على الحجم وكثافة الماء";
const DESCRIPTION =
  "حاسبة كتلة الماء الدقيقة: احسب كتلة الماء (بالجرام أو الكيلوجرام) بسهولة! أدخل حجم الماء (لتر، ملليلتر، م³) ودرجة الحرارة (لضبط الكثافة) للحصول على نتائج فورية - أساسية للكيمياء، الفيزياء، والهندسة.";
const KEYWORDS = "كتلة الماء, حساب كتلة الماء, حاسبة كتلة الماء";
const OG_URL = "https://do-calculate.com/calculator/ar/water-mass/";
function Calculator() {
  const [waterVolume, setWaterVolume] = useState("");
  const [waterMass, setWaterMass] = useState("");
  const [error, setError] = useState("");
  const waterDensity = 1000;
  const handleCalculate = () => {
    if (!waterVolume) {
      setError("الرجاء إدخال حجم الماء بالمتر المكعب بشكل صحيح");
      setWaterMass("");
      return;
    }
    const volumeValue = parseFloat(waterVolume);
    if (isNaN(volumeValue) || volumeValue < 0) {
      setError("الرجاء إدخال قيمة صحيحة وغير سالبة لحجم الماء بالمتر المكعب");
      setWaterMass("");
      return;
    }
    const mass = volumeValue * waterDensity;
    setWaterMass(mass.toFixed(2));
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>طريقة حساب كتلة الماء</h2>
                <p>
                  لحساب كتلة الماء، يتم استخدام العلاقة بين الحجم وكثافة الماء. يجب عليك إدخال حجم الماء بوحدات المتر المكعب، ثم يتم ضرب هذا الحجم في كثافة الماء للحصول على الكتلة بوحدات الكيلوغرام.
                </p>
                <p>
                  <strong>صيغة الحساب:</strong> <br />
                  كتلة الماء = الحجم (متر مكعب) × كثافة الماء (كيلوغرام/متر مكعب)
                </p>
                <p>
                  يمكنك استخدام هذه الحاسبة لتحديد كتلة الماء بدقة بناءً على القيم التي تقوم بإدخالها. ما عليك سوى إدخال الحجم والكثافة، وستحصل على النتيجة بسرعة وسهولة.
                </p>
                <b >
                  تاريخ آخر تحديث: {" "}
                  <time dateTime="2026-01-10">28/02/2026</time>
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          حجم الماء (متر مكعب)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="حجم الماء بالمتر المكعب"
                        value={waterVolume}
                        onChange={(e) => setWaterVolume(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب كتلة الماء
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {waterMass !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              كتلة الماء: {waterMass} كيلوغرام
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              هذه القيمة تُمثل الكتلة التي يمثلها الماء بناءً
                              على الحجم الذي قمت بإدخاله وكثافة الماء.
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h2 style={{ fontSize: "18px" }}>{TITLE}</h2>
            </div>
            <div className="info-section-body">
              <p>{DESCRIPTION}</p>
              <div>
                <h3 style={{ fontSize: '16px' }}>كيفية حساب كتلة الماء</h3>
                <p>لحساب كتلة الماء، تحتاج إلى معرفة حجم الماء وكثافة الماء. تتبع الخطوات التالية:</p>
                <ul>
                  <li><strong>أدخل حجم الماء:</strong> يتم قياس الحجم بالمتر المكعب (م³).</li>
                  <li><strong>أدخل كثافة الماء:</strong> الكثافة العامة للماء هي 1000 كيلوجرام لكل متر مكعب (كجم/م³).</li>
                </ul>
                <p>ثم يتم حساب الكتلة باستخدام الصيغة التالية:</p>
                <p><strong>كتلة الماء = الحجم (متر مكعب) × كثافة الماء (كيلوغرام/متر مكعب)</strong></p>
                <p>هذه الصيغة تعتمد على الكثافة الثابتة للماء، والتي تكون تقريباً 1000 كجم/م³ عند درجة حرارة الغرفة.</p>
              </div>
              <hr />
              <div>
                <h3 style={{ fontSize: '16px' }}>مثال على حساب كتلة الماء</h3>
                <p>لنفترض أنك تريد حساب كتلة 2 متر مكعب من الماء. باستخدام الكثافة الثابتة للماء، نقوم بما يلي:</p>
                <div className='p-3 mb-2 bg-info'>
                  <strong>كتلة الماء = الحجم × كثافة الماء = 2 م³ × 1000 كجم/م³ = 2000 كجم</strong>
                </div>
                <p>في هذا المثال، كتلة الماء هي 2000 كيلوجرام. يمكنك استخدام هذه الحاسبة لتحديد كتلة الماء لأي حجم تحدده.</p>
              </div>
              <hr />
              <div>
                <h3 style={{ fontSize: '16px' }}>نصائح حول حساب كتلة الماء</h3>
                <p>تأكد من إدخال حجم الماء بالكميات الصحيحة، والتأكد من استخدام الكثافة المناسبة للماء. يمكن أن تختلف كثافة الماء بناءً على درجة الحرارة، ولكن القيم المستخدمة في هذا المثال تتوافق مع الكثافة القياسية عند درجة حرارة الغرفة. لمزيد من المعلومات حول استخدام هذه الحاسبة وتطبيقاتها العملية، يمكنك الاطلاع على المصادر التالية:</p>
                <ul>
                  <li><a href="https://www.engineeringtoolbox.com/water-density-specific-weight-d_595.html" rel="nofollow noreferrer" target="_blank">Engineering ToolBox - Water Density</a></li>
                </ul>
                <p>تم تطوير هذه الحاسبة بناءً على المبادئ والبيانات الموثوقة من المصادر المذكورة أعلاه.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Calculator;
